import { render, staticRenderFns } from "./sale-item-detail.vue?vue&type=template&id=8028918a&"
import script from "./sale-item-detail.vue?vue&type=script&lang=js&"
export * from "./sale-item-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports